import axios from "axios";
import store from "@/store";
import router from "@/router";
import { getToken } from "@/utils/auth";
import { Loading, MessageBox } from "element-ui";
// 请求计数器
let activeRequests = 0;
let loadingInstance = null;

// 管理loading状态
const loading = {
  // 显示全局loading
  show() {
    if (!loadingInstance) {
      loadingInstance = Loading.service({
        fullscreen: true,
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    }
  },
  
  // 隐藏loading
  hide() {
    if (loadingInstance) {
      loadingInstance.close();
      loadingInstance = null;
    }
  },
  
  // 开始新请求
  start() {
    if (activeRequests === 0) {
      this.show();
    }
    activeRequests++;
  },
  
  // 结束请求
  end() {
    activeRequests--;
    if (activeRequests === 0) {
      this.hide();
    }
  }
};
const service = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL,
    timeout: 500000
});

// 请求拦截器
service.interceptors.request.use(
    (config) => {
        // 显示loading，除非明确跳过
        if (config.skipLoading !== true) {
            loading.start();
        }
        config.headers["userId"] = getToken();
        const authHeader = sessionStorage.getItem("Authorization");
        if (authHeader) {
            config.headers["authorization"] = authHeader;
        }
        return config;
    },
    (error) => {
        loading.end();
        return Promise.reject(error);
    }
);

// 响应拦截器
service.interceptors.response.use(
    (response) => {
        // 请求完成，减少计数
        if (response.config.skipLoading !== true) {
            loading.end();
        }
        const res = response.data;
        // 如果 code 是 410（用户不存在），弹出提示框后清空 session 并跳转登录页
        if (Number(res.code) === 410) {
            MessageBox.confirm(res.msg || "用户信息已过期，请重新登录", "提示", {
                confirmButtonText: "确定",
                type: "warning",
                showCancelButton: false,
                closeOnClickModal: false,
                closeOnPressEscape: false
            }).then(() => {
                store.dispatch("user/resetToken").then(() => {
                    router.replace({ path: "/" });
                });
            });
            return Promise.reject(res);
        }
        if (Number(res.code) === 200) {
            return res;
        }
        return Promise.reject(res);
    },
    (error) => {
        // 错误时也需要减少计数
        if (error.config && error.config.skipLoading !== true) {
            loading.end();
        }
        // 处理响应错误中的 410 状态码
        let res = null;
        if (error.response && error.response.data) {
            res = error.response.data;
        } else if (error.code || error.msg) {
            // 处理在响应拦截器中 reject 的 res 对象
            res = error;
        }
        if (res && Number(res.code) === 410) {
            MessageBox.confirm(res.msg || "用户信息已过期，请重新登录", "提示", {
                confirmButtonText: "确定",
                type: "warning",
                showCancelButton: false,
                closeOnClickModal: false,
                closeOnPressEscape: false
            }).then(() => {
                store.dispatch("user/resetToken").then(() => {
                    router.replace({ path: "/" });
                });
            });
        }
        return Promise.reject(error);
    }
);

export default service;
